module.exports = __webpack_public_path__ + "img/bm.d1c8883d.svg";